// @flow
import { get } from 'lodash';
import { resolve } from 'redux-optimist-promise';

import {
  CLEAR_ADDITIONAL_TRANSPORTS,
  FETCH_ADDITIONAL_TRANSPORTS,
} from 'Store/booking/additional-transports/additionalTransports.action';

type State = ?Array<AdditionalTransport>;

const initialState: State = null;

function transportsReducer(state: State = initialState, action: ?Action<*>): State {
  switch (get(action, 'type')) {
    case CLEAR_ADDITIONAL_TRANSPORTS:
      return initialState;

    case FETCH_ADDITIONAL_TRANSPORTS:
      return initialState;

    case resolve(FETCH_ADDITIONAL_TRANSPORTS):
      return get(action, 'payload.additionalTransports', []).map((transport, index) => ({
        ...transport,
        transportNumber: index + 1,
      }));

    default:
      return state;
  }
}

export default transportsReducer;
